import React, { Fragment } from "react";
import Table from "react-bootstrap/Table";
import ButtonComponent from "../UI/ButtonComponent/ButtonComponent";
import Badge from "react-bootstrap/Badge";
import {
  FormOutlined,
  ZoomInOutlined,
  EditOutlined,
  MinusCircleOutlined,
  DownloadOutlined,
  HistoryOutlined,
  CheckOutlined
} from "@ant-design/icons";
import "./PregledTable.css";
import { Tooltip } from "antd";

const OsobeTable = (props) => {
  let label = "";
  let vrOsobe;

  if (props.formId == 1) {
    label = "REGISTAR OVLAŠTENIH REVIZORA";
    vrOsobe = 1;
  } else if (props.formId == 4) {
    label = "REGISTAR REVIZORSKIH VJEŽBENIKA";
    vrOsobe = 2;
  } else if (props.formId == 6) {
    label = "REGISTAR OVLAŠTENIH REVIZORA IZ DRUGIH DRŽAVA ČLANICA";
    vrOsobe = 3;
  } else if (props.formId == 8) {
    label = "REGISTAR OVLAŠTENIH REVIZORA IZ TREĆIH ZEMALJA";
    vrOsobe = 4;
    // label = "REGISTAR REVIZORA U TREĆOJ ZEMLJI";
  }

  const poruka =
    props.children && props.children.length == 0 ? (
      <div style={{ textAlign: "center", marginTop: "0px" }}>
        <p className="search-result-text">Zadana pretraga nema rezultata.</p>
      </div>
    ) : null;

  const { userRole } = props;

  const checkIfUserIsAdmin =
    userRole === "ROLE_REFERENT" || userRole === "ROLE_SLUZBENIK";

  return (
    <>
      {props.children && props.children.length != 0 ? (
        <div
          style={{
            display: "inline-flex",
            alignItems: "center",
            marginBottom: ".5rem",
          }}
        >
          <h5
            style={{
              lineHeight: "1.2",
              margin: "0 8px 0",
            }}
          >
            {label}
          </h5>

          <Tooltip title="Preuzmi registar u CSV">
            <ButtonComponent
              className="download_csv"
              onClick={(e) => props.exportRegistar("osoba", vrOsobe, label)}
              variant="secondary"
            >
              <DownloadOutlined />
            </ButtonComponent>{" "}
          </Tooltip>
        </div>
      ) : null}
      {poruka}
      <Table responsive bordered hover>
        <thead>
          {props.children && props.children.length != 0 ? (
            <tr className="tr_table">
              <th scope="col">Prezime</th>
              <th scope="col">Ime</th>
              <th scope="col">Registarski broj</th>
              {props.formId != 1 && props.formId != 4 ? (
                <th scope="col">Država</th>
              ) : null}
              <th scope="col">Detalji</th>
              {checkIfUserIsAdmin ? (
                <Fragment>
                  <th scope="col">Povijest</th>
                  <th scope="col">Ažuriraj bez zahtjeva</th>
                  <th scope="col">Ažuriraj po zahtjevu</th>
                  <th scope="col">Akcija</th>
                  <th scope="col">Status</th>
                </Fragment>
              ) : null}
            </tr>
          ) : null}
        </thead>
        <tbody>
          {props.children &&
            props.children.map(
              (element) =>
                ((!props.isAuthenticated && element.osoba.oznAkt == "1") ||
                  (props.userRole == "ROLE_KORISNIK" &&
                    element.osoba.oznAkt == "1") ||
                  checkIfUserIsAdmin) && (
                  <tr key={element.osoba.idOsobe}>
                    <td>{element.osoba.prezime}</td>
                    <td>{element.osoba.ime}</td>
                    <td>{element.osoba.regBroj}</td>

                    {props.formId != 1 && props.formId != 4 ? (
                      <td>{element.osoba.nazDrzave}</td>
                    ) : null}
                    <td className="ant_batn">
                      <ButtonComponent
                        variant="secondary"
                        onClick={(e) =>
                          props.detaljiClicked(
                            element.osoba.idOsobe,
                            element.osoba.vrOsobe,
                            "osoba",
                            false
                          )
                        }
                      >
                        <ZoomInOutlined />
                      </ButtonComponent>
                    </td>
                    {checkIfUserIsAdmin ? (
                      <Fragment>
                        <td className="ant_batn">
                          <ButtonComponent
                            disabled={element.osoba.oznAkt === 2}
                            variant="secondary"
                            onClick={(e) =>
                              props.povijestClicked(
                                element.osoba.regBroj,
                                "osoba"
                              )
                            }
                          >
                            <HistoryOutlined />
                          </ButtonComponent>
                        </td>
                        <td className="ant_batn">
                          <ButtonComponent
                            variant="secondary"
                            onClick={(e) =>
                              props.redirectHandler(
                                e,
                                element.osoba.idOsobe,
                                element.osoba.vrOsobe
                              )
                            }
                            disabled={element.osoba.oznAkt == 2 ? true : false}
                          >
                            <EditOutlined />
                          </ButtonComponent>
                        </td>
                        <td className="ant_batn">
                          <ButtonComponent
                            variant="secondary"
                            onClick={(e) =>
                              props.azurirajClicked(
                                e,
                                element.osoba.idOsobe,
                                element.osoba.vrOsobe,
                                element.osoba.regBroj
                              )
                            }
                            disabled={element.osoba.oznAkt == 2 ? true : false}
                          >
                            <FormOutlined />
                          </ButtonComponent>
                        </td>
                        {element.osoba.oznAkt == 2 ? (
                        <td className="aktivirajButton ant_batn">
                          <Tooltip title="Aktiviraj subjekt">
                          <ButtonComponent
                            onClick={(e) =>
                              props.aktivirajClicked(
                                "osoba",
                                element.osoba.idOsobe
                              )
                            }
                            //disabled={element.osoba.oznAkt == 2 ? true : false}
                            variant="secondary"
                            // style={{backgroundColor:"#dc3545", border:"none", color:"white"}}
                          >
                            <CheckOutlined />
                          </ButtonComponent> {" "}
                          </Tooltip>
                        </td> ) : (
                        <td className="disableButton ant_batn">
                          <Tooltip title="Deaktiviraj subjekt">
                          <ButtonComponent
                            onClick={(e) =>
                              props.deaktivirajClicked(
                                "osoba",
                                element.osoba.idOsobe,
                                element.osoba.vrOsobe
                              )
                            }
                           // disabled={element.osoba.oznAkt == 2 ? true : false}
                            variant="secondary"
                            // style={{backgroundColor:"#dc3545", border:"none", color:"white"}}
                          >
                            <MinusCircleOutlined />
                          </ButtonComponent>{" "}
                          </Tooltip>
                        </td>)}
                        <td>
                          {element.osoba.oznAkt == 1 ? (
                            <Badge pill variant="success">
                              Aktivan
                            </Badge>
                          ) : (
                            <Badge pill variant="danger">
                              Brisan
                            </Badge>
                          )}
                        </td>
                      </Fragment>
                    ) : null}
                  </tr>
                )
            )}
        </tbody>
      </Table>
    </>
  );
};

export default OsobeTable;
